.locations-component {

  .locations-filter {
    padding: 30px;

    select {
      color: #505050;
      font-weight: 400;
      @include text-size(15);
    }
  }

  .locations-intro {
    padding: 30px 30px 0 30px;

    p:last-of-type {
      padding: 0;
      margin: 0;
    }

    h1 {
      margin: 0 0 16px 0;
    }
  }

  .locations-filter {
    .geo-search {
      position: relative;

      svg {
        @include svg-format(21px, 21px, $primary);
        position: absolute;
        top: 12px;
        left: 12px;
      }

      .clear-places-autocomplete {
        display: none;
        position: absolute;
        width: 21px;
        height: 21px;
        top: 10px;
        right: 12px;

        svg {
          position: static;
          @include svg-format(21px, 21px, $primary);
        }
      }
    }

    label {
      @include text-size(15);
      @include line-height(18);
      font-family: $font-family-secondary;
      font-weight: 600;
      text-transform: uppercase;
      padding: 5px 0;
      margin-bottom: 0;
      color: $primary;
    }

    select {
      background-image: none;
      min-height: none;
      padding: 11px 10px;
    }

    .form-select-wrapper {
      display: flex;
      align-items: center;

      label {
        margin-right: 16px;
      }

      .select-wrapper {
        flex: 1 1 auto;
      }
    }

    .select-wrapper {
      svg {
        right: 13px;
      }
    }

    .kdx-dropdown-list {
      margin-bottom: 10px;

      & > a {
        padding: 10px 30px 10px 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .svg-icon {
        @include svg-format(18px, 18px, $primary);
        right: 13px;
      }
    }

    .locations-text-search {
      padding: 10px 40px 10px 40px;
      color: #505050;
      border-radius: 8px;

      @include placeholder() {
        color: #505050;
        font-style: italic;
      }
    }

    .form-check {
      padding: 5px 10px 0 10px;

      &:hover {
        background: #f2f2f2;
      }

      input {
        margin-left: 0;
      }

      .location-ico {
        width: 32px;
        float: right;
        text-align: center;
        padding-top: 2px;

        img {
          max-width: 100%;
          max-height: 22px;
        }
      }
    }

    .kdx-checkbox {
      & > .form-check-label {
        line-height: normal;
        padding-top: 3px;
        margin-left: 10px;
        max-width: calc(100% - 80px);
      }
    }
  }

  .info-window {
    color: #000;
    border-radius: 8px;

    .title {
      font-family: $font-family-primary;
      @include text-size(15);
      @include line-height(18);
      color: $locationCardHeadline;
      text-transform: none;
    }

    .chapter-info-item {
      display: flex;
      align-items: flex-start;
      @include text-size(12);
      @include line-height(18);
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        min-width: 70px;
        color: $locationCardLabel;
        font-weight: 700;
        margin-right: 5px;
      }

      a {
        text-decoration: none;
        color: #000;

        &:hover, &:focus {
          text-decoration: underline;
        }
      }
    }
  }

  .gm-style {
    font-family: $font-family-primary;
  }

  .gm-style .gm-style-iw-c {
    border-radius: 8px;
    border: none;
  }

  .gm-style .gm-style-iw-t .gm-ui-hover-effect {
    opacity: 1;

    span {
      background-color: $locationCardHeadline;
    }

    &:hover, &:focus {
      opacity: .6;
    }
  }

  &#{&}-full {

    .container {
      max-width: none;
      padding: 0;

      [class|="col"] {
        padding: 0;
      }
    }

    .locations-row {
      display: grid;
      grid-template-columns: 411px auto;
      grid-template-rows: 1fr 1fr;
      padding: 0;
      margin: 0;
    }

    .location-panel-wrapper {
      grid-column: 1 / 2;
      grid-row: 1 / 2;
    }

    .locations-listing-wrapper {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
      max-height: 766px;
      overflow: auto;
    }

    .locations-map-col {
      grid-column: 2 / 3;
      grid-row: 1 / 3;
    }
  }
}

.locations-component.locations-component-full .locations-panel {
	.kdx-breadcrumbs {
		padding: 0 60px;

		.kdx-breadcrumbs {
			padding: 0 30px;
		}

		ul {
			margin: 10px 0 0 0;

			li {
				padding-bottom: 0;
			}
		}
	}
}
#specialty-assemblies ul li {
  background-color: #fff;
  width: 98%;
  margin: 12px 0;
  padding: 0;

  .card-body {
    padding: 20px;
  }

  a {
    color: #003d54;
    text-decoration: none;
    font-family: "Open Sans";
    font-weight: 700;

    &:hover {
      text-decoration: underline;
    }
  }
}

// IE11 display hack
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
	.locations-component > .container {
		width: calc(100% + 40px);
		margin: 0 0 0 -20px;
	}
}






@include media-breakpoint-down(md) {
	.locations-component {

		&.locations-component-full {
			.locations-row {
				grid-template-columns: 100%;
				grid-template-rows: auto 284px auto;
			}
			.location-panel-wrapper {
				grid-column: 1;
				grid-row: 1 / 2;
			}
			.locations-listing-wrapper {
				grid-column: 1;
				grid-row: 3 / 4;
				height: auto;				
			}
			.locations-map-col {
				grid-column: 1;
				grid-row: 2 / 3;
				height: 284px;

				.locations-map { min-height: 284px; }
			}
		}
		.locations-filter { padding: 16px 30px; }
		.locations-intro {
			@include text-size(12);
			@include line-height(20);			
		}
	}
}
